module.exports = "<div class=\"modal-body\">\n  <div class=\"container\">\n    \n    <app-dynamic-form-question\n    *ngFor=\"let subQuestion of subQuestions\"\n    [question]=\"subQuestion\"\n    [form]=\"form\"\n    [hidden]=\"!subQuestion.visible\"\n    >\n    </app-dynamic-form-question>\n  \n  </div>\n  <a href=\"javascript:void(0)\" class=\"backModalLink\" (click)=\"back()\">Zurück</a>\n  <button type=\"button\" class=\"btn saveModalBtn\" (click)=\"save()\">Speichern</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal-content/modal-content.component.html
// module id = ./src/app/modal-content/modal-content.component.html
// module chunks = main